import { render } from "./ContactsPeople.vue?vue&type=template&id=56978e18"
import script from "./ContactsPeople.vue?vue&type=script&lang=js"
export * from "./ContactsPeople.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__